import { useCallback, useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

import { emitSessionExpired } from '@/shared/lib/events/sessionExpired';
import { checkSessionByFetch } from '@/shared/lib/session';

const IS_LOCAL = import.meta.env.DEV;
const IS_DEMO_MODE = import.meta.env.MODE === 'demo';

/**
 * 화면 이동 시 세션 유효성을 체크합니다.
 * fetch API를 사용하여 302 리다이렉트를 감지합니다.
 */
export const useSessionCheck = () => {
  const location = useLocation();
  const isCheckingRef = useRef<boolean>(false);

  const checkSession = useCallback(async () => {
    if (IS_LOCAL || IS_DEMO_MODE) {
      return;
    }

    if (isCheckingRef.current) {
      console.warn('[useSessionCheck] ⏸️ 세션 체크 중복 호출 방지 - 스킵');
      return;
    }

    console.warn('[useSessionCheck] 🔍 STEP 1: 화면 전환 감지 - 세션 체크 시작', {
      pathname: window.location.pathname,
    });

    isCheckingRef.current = true;

    try {
      const isSessionValid = await checkSessionByFetch();

      if (!isSessionValid) {
        console.warn('[useSessionCheck] ❌ STEP 3: 세션 만료 감지 - Keycloak 리다이렉션 시작');
        emitSessionExpired();
      } else {
        console.warn('[useSessionCheck] ✅ 세션 유효 - 체크 완료');
      }
    } catch (error) {
      console.error('[useSessionCheck] ⚠️ 세션 체크 실패:', error);
    } finally {
      isCheckingRef.current = false;
    }
  }, []);

  useEffect(() => {
    console.warn('[useSessionCheck] 📍 화면 전환 감지:', location.pathname);
    checkSession();
  }, [location.pathname, checkSession]);
};
